import DraggableAdditionalInfoCard from './draggableAdditionalInfoCard.container';

export default DraggableAdditionalInfoCard;